import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from 'react-router-dom'

import "common/css/master.css";
import "./panel.css";

import Header from "common/js/header/header";
import Loader from "common/components/Loader";
import PanelTbl from "./panelTbl";

import { getPanelListSvc, slideShowPanel } from "./panelSvc";
import PanelSlider from "./panelSlider";
import PanelContentSlider from "./panelContentSlider";
import lstModules from 'common/json/lstModules.json';
const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;

function PanelCtrl() {
  const [loader, setLoader] = useState("none");
  const [opacity, setOpacity] = useState(1);
  const [lstPanel, setLstPanel] = useState([]);
  const [flgPanelSliderVisible, setFlgPanelSliderVisible] = useState(false);
  const [flgPanelContentSliderVisible, setFlgPanelContentSliderVisible] = useState(false);
  const [panelObj, setPanelObj] = useState({});
  const [key, setKey] = useState(0);

  const [flgShowSlide, setFlgShowSlide] = useState('none');
  const [isFullscreen, setIsFullscreen] = useState(false); // Track fullscreen state
  const [content, setContent] = useState([]);  // Stores the content for the slideshow
  const [currentIndex, setCurrentIndex] = useState(0); // Index for the current content to show
  const [data, setData] = useState({})
  const [panelId, setPanelId] = useState(0);
  const [contentBasePath, setContentBasePath] = useState('');
  const [lstPanelPlayContentMap, setLstPanelPlayContentMap] = useState(new Map());
  const [layoutTypeId, setLayoutTypeId] = useState(0);



  // Fetch content based on panelId
  useEffect(() => {
    getPanelList();
  }, [key]);

  useEffect(() => {

    const handleEscape = async (event) => {
      if (event.key == 'Escape') {
        // console.log('Escape key pressed!');
        closeFullscreen()
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [])

  const requestFullScreen = async (element) => { // You can change this to specific elements
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) { // Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) { // Chrome, Safari, Opera
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { // IE/Edge
      element.msRequestFullscreen();
    }
    await setIsFullscreen(true);
    await setFlgShowSlide('flex');
  };

  // Handle the slideshow progression based on content duration
  useEffect(() => {
    if (content.length > 0) {
      const currentContent = content[currentIndex];
      const timer = setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % content.length);  // Cycle through content
      }, currentContent.displayTm * 1000); // content.duration is in seconds

      return () => clearTimeout(timer);  // Cleanup timeout on each re-render
    }
  }, [currentIndex, content]);

  const currentContent = content[currentIndex];


  async function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(err =>
        console.error("Error exiting fullscreen:", err)
      );
    } else if (document.mozCancelFullScreen) { // Firefox
      document.mozCancelFullScreen().catch(err =>
        console.error("Error exiting fullscreen:", err)
      );
    } else if (document.webkitExitFullscreen) { /* Safari */
      document.webkitExitFullscreen().catch(err =>
        console.error("Error exiting fullscreen:", err)
      );
    } else if (document.msExitFullscreen) { /* IE11 */
      document.msExitFullscreen().catch(err =>
        console.error("Error exiting fullscreen:", err)
      );
    }
    const videos = document.querySelectorAll('video');
    videos.forEach((video) => {
      video.pause();
    });

    await setCurrentIndex(0);
    await setIsFullscreen(false);
    await setFlgShowSlide('none');

  }



  const handleVideoEnd = () => {
    // console.log("Video has ended!");
    setCurrentIndex((prevIndex) => (prevIndex + 1) % content.length);
    // You can trigger additional logic here if needed, like resetting the state
  };

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key == 'Escape' && isFullscreen) {
        closeFullscreen();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isFullscreen]);



  const getPanelList = () => {
    // console.log("getPanelList called");
    setLoader("block");
    setOpacity(0.5);
    getPanelListSvc(panelListResponse);
  }


  const panelListResponse = (data) => {
    // console.log("panelListResponse called, data", data);
    if (data.status === "Success") {
      // console.log("inside panelListResponse, data.lstPanel", data.lstPanel);
      setLstPanel(data.lstPanel);
      if (data.lstPanel) {
        getPanelPlayContent(data.lstPanel);
      }
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setLoader("none");
    setOpacity(1);
  }

  const getPanelPlayContent = (pLstPanel) => {
    // console.log("getPanelPlayContent called, pLstPanel", pLstPanel);
    for (let i = 0; i < pLstPanel.length; i++) {
      setLoader("auto");
      setOpacity(0.5);
      slideShowPanel(pLstPanel[i].panelId, panelPlayContentResponse);
    }
  }

  const panelPlayContentResponse = (data) => {
    // console.log("panelPlayContentResponse called, data", data);
    // console.log("panelId", data.panelId);
    // console.log("contentBasePath", data.contentBasePath);
    // console.log("lstPanelPlayContent", data.lstPanelPlayContent);
    if (data.status === "Success") {
      setContentBasePath(data.contentBasePath);

      setLstPanelPlayContentMap((prevMap) => {
        const newMap = new Map(prevMap);
        // Create an updated list for the panel's content
        const updatedContent = data.lstPanelPlayContent.map((obj, index) => {
          if (obj.mediaTypeId !== 10) {
            const videoElement = document.createElement('video');
            videoElement.src = `https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${data.contentBasePath}/${obj.fileNm}`;
            // videoElement.src = `${httpURL}/sms/student/docs/view?imgPath=${data.contentBasePath}/${obj.fileNm}`;
            videoElement.muted = false;

            // Calculate and set displayTm asynchronously
            videoElement.onloadedmetadata = () => {
              setLstPanelPlayContentMap((prevMap) => {
                const updatedMap = new Map(prevMap);
                const currentPanelContent = updatedMap.get(data.panelId) || [];
                currentPanelContent[index] = {
                  ...currentPanelContent[index],
                  displayTm: videoElement.duration
                };
                updatedMap.set(data.panelId, currentPanelContent);
                return updatedMap;
              });
            };
          }
          return obj; // Return the object as it is
        });
        // Update the map with the new content for this panelId
        newMap.set(data.panelId, updatedContent);
        return newMap;
      });

    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setLoader("none");
    setOpacity(1);
  }

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };

  const addPanel = async () => {
    // console.log("addPanel called");
    await setPanelObj({});
    await setFlgPanelContentSliderVisible(false);
    setFlgPanelSliderVisible(true);
  }

  const handleChangePanelObj = () => {
  }

  const editPanel = async (panel) => {
    // console.log("editPanel called, panel", panel);
    await setPanelObj(panel);
    await setFlgPanelContentSliderVisible(false);
    setFlgPanelSliderVisible(true);
  }

  const deletePanel = async (panel) => {
    // console.log("deletePanel called, panel", panel);
    await setPanelObj(panel);
  }

  const editPanelContent = async (panel) => {
    // console.log("editPanelContent called, panel", panel);
    await setPanelObj(panel);
    await setFlgPanelSliderVisible(false);
    setFlgPanelContentSliderVisible(true);
  }

  const closeSlider = () => {
    setFlgPanelContentSliderVisible(false);
    setFlgPanelSliderVisible(false);
    setPanelObj({});
  }


  const playPanel = async (panel) => {
    // console.log("playPanel called, panel", panel);
    setLayoutTypeId(panel.layoutTypeId);
    await setPanelObj(panel);
    if (panel.panelId != 0) {
      await setContent(lstPanelPlayContentMap.get(panel.panelId));
      requestFullScreen(document.getElementById('slideshow'))
    }
  }

  const updateKey = () => {
    setKey(prevKey => prevKey + 1);
  }

  return (
    <div >
      <Header />
      <ToastContainer autoClose={3000} hideProgressBar />
      <Loader loader={loader} position="fixed" />
      <div className="col-md-12 col-xs-12 col-centered padding-remove"
        style={{
          cursor: (loader === "none") ? 'pointer' : 'none',
          pointerEvents: (loader === "none") ? 'auto' : 'none',
          opacity: opacity
        }}>
        <div className="col-xl-10 col-lg-10 col-md-11 col-sm-11 col-xs-11 col-centered padding-remove" style={{ marginTop: "35px" }}>
          <div className="col-md-11 col-sm-11 col-xs-11  padding-remove" >
            <PanelTbl
              key={lstPanel}
              lstPanel={lstPanel}
              panelId={panelId}
              handleChangePanelObj={handleChangePanelObj}
              editPanel={editPanel}
              deletePanel={deletePanel}
              editPanelContent={editPanelContent}
              playPanel={playPanel}
            />
          </div>
          <div className="col-md-1 col-sm-1 col-xs-1 text-center padding-remove" >
            <span
              id="addContent"
              title="Add Content"
              className="addIcon glyphicon glyphicon-plus-sign"
              onClick={() => addPanel()}
            ></span>
          </div>
        </div>
      </div>
      <div id="slideshow" style={{ width: '100%', height: '100%', background: '#1c1c1c', display: flgShowSlide, justifyContent: 'center', alignItems: 'center', textAlign:"center" }}>
        <div className="col-sm-12 col-centered" style={{height:"100%"}}>
          {currentContent?.mediaTypeId === 10 ? (
            <img
              src={`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${contentBasePath}/${currentContent.fileNm}`}
              // src={`${httpURL}/sms/student/docs/view?imgPath=${contentBasePath}/${currentContent.fileNm}`}
              alt={currentContent.name}
              // style={{ width: '100%', height: 'auto' }}
              className={layoutTypeId === 20 ? "slide-fullHeight" : "slide-fullWidth"}
            />
          ) : currentContent?.mediaTypeId === 20 ? (
            <video
              src={`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${contentBasePath}/${currentContent.fileNm}`}
              // src={`${httpURL}/sms/student/docs/view?imgPath=${contentBasePath}/${currentContent.fileNm}`}
              controls
              autoPlay
              muted={false}
              // style={{ width: '100%', height: 'auto' }}
              className={layoutTypeId === 20 ? "slide-fullHeight" : "slide-fullWidth"}
              onEnded={handleVideoEnd}
            />
          ) : null}
        </div>
      </div>
      {
        flgPanelSliderVisible ?
          <div className="slider1-60">
            <PanelSlider
              panelDtls={panelObj}
              deletePanel={deletePanel}
              closeSlider={closeSlider}
              updateKey={updateKey}
            />
          </div>
          : null
      }
      {
        flgPanelContentSliderVisible ?
          <div className="slider1-60">
            <PanelContentSlider
              panelDtls={panelObj}
              closeSlider={closeSlider}
            />
          </div>
          : null
      }
    </div>
  )
}

export default PanelCtrl;



